'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthApi } from '@/api';
import { invalidateExceptCommentLists, patchCommentInAllLists, reconcileCommentListsAfterChange } from './commentListSync';
interface UsePutCommentMutationParams {
  /** 수정 대상 댓글 id */
  commentId: number;
  /** 성공 시 상위에서 모드 종료와 스크롤 복원을 처리 */
  onSuccess?: () => void;
}

// 댓글 수정 API와 목록 낙관 반영을 함께 처리한다.
export const usePutCommentMutation = t0 => {
  const $ = _c(13);
  const {
    commentId,
    onSuccess
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== commentId) {
    t1 = contents => AuthApi["put:/wello/v2/auth/wello-comment/{welloCommentId}"]({
      path: {
        welloCommentId: commentId
      },
      body: {
        contents
      }
    });
    $[0] = commentId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== commentId || $[3] !== onSuccess || $[4] !== queryClient || $[5] !== toast) {
    t2 = (_, contents_0) => {
      toast({
        type: "success",
        message: "\uB313\uAE00 \uC218\uC815\uC644\uB8CC"
      });
      patchCommentInAllLists(queryClient, commentId, {
        contents: contents_0
      });
      onSuccess?.();
      invalidateExceptCommentLists(queryClient);
      reconcileCommentListsAfterChange({
        queryClient,
        commentId,
        checkReflected: comment => comment?.contents === contents_0
      });
    };
    $[2] = commentId;
    $[3] = onSuccess;
    $[4] = queryClient;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== toastError) {
    t3 = error => {
      toastError({
        error
      });
    };
    $[7] = toastError;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return useMutation(t4);
};